import { useInfiniteQuery, useMutation } from 'react-query';
import financialConfigurationService from './FinancialConfiguration.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useFinancialConfigurationProfile() {
  return useInfiniteQuery(
    ['financial/configuration/profile'],
    financialConfigurationService.getFinancialConfigurationProfile,
    {
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useFinancialConfigurationUpdate() {
  const queryChanel = useQueryChanel();
  return useMutation(
    financialConfigurationService.updateFinancialConfigurationProfile,

    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Configuração atualizada com sucesso!',
        });

        queryChanel({
          invalidateQueries: [['financial/configuration/profile']],
        });
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
}
